import React, { useState } from 'react'
import Card from '@mui/material/Card';
import Dialog from '@mui/material/Dialog';
import Zoom from '@mui/material/Zoom';

type Props = {
    image_url: string;
    image_create_obj_url?: any;
    render_image: React.ReactNode;
    disable_show: boolean;
    disabled_max_width?: boolean;
}

const PreviewImage: React.FC<Props> = ({ image_url, render_image, disable_show, image_create_obj_url, disabled_max_width }: Props) => {
    const [open, setOpen] = useState<boolean>(false);
    const [loaded, setLoaded] = useState<boolean>(false);

    const handleClickOpen = () => {
        !disable_show && setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <div className='w-full h-full'>
            <Card className='w-full h-full cursor-pointer hover:opacity-70 transition-all' sx={{ maxWidth: disabled_max_width ? 'auto' : 200 }} onClick={(e) => {
                e.stopPropagation();
                handleClickOpen();
            }}>
                {render_image}
            </Card>
            <Dialog
                TransitionComponent={Zoom}
                open={open} onClose={handleClose}>
                <img
                    onLoad={() => setLoaded(true)}
                    src={image_create_obj_url || image_url}
                    alt="preview-image"
                    style={{
                        width: '100%', height: 'auto', objectFit: "cover", transition: 'filter 0.6s ease-out',
                        filter: loaded ? 'none' : 'blur(10px)',
                    }}
                />
            </Dialog>
        </div>
    )
}

export default PreviewImage